import type { EasyDoctorLinkProps } from '@easydoctor/ui';
import { forwardRef } from 'react';
import { Link } from 'react-router';

/**
 * Adattatore di react-router per i componenti di `@easydoctor/ui` che navigano (`AppShell`, `DataTable`
 * con `getRowHref`), come `EasyDoctorRouterLink` di EasyCare: il pacchetto passa `href` (mai `to`) e
 * questo lo gira a `Link`, che rende un vero `<a href>` e naviga lato client (schema «LinkBehavior» di
 * MUI). `className`, `aria-current`, `aria-label`, `onClick` e gli attributi `data-*` arrivano al DOM.
 *
 * @example
 * <DataTable getRowHref={(row) => `/ticket/${row.code}`} LinkComponent={RouterLink} … />
 */
export const RouterLink = forwardRef<HTMLAnchorElement, EasyDoctorLinkProps>(function RouterLink(
  { href, ...props },
  ref
) {
  return <Link ref={ref} to={href} {...props} />;
});
